import { BalloonEventModel } from './BalloonEventModel';

export class UserModel {
  private _id: string | null = null;
  private _token: string;
  private _email: string | null = null;
  private _name: string | null = null;
  private _avatar: string | null = null;
  private _hasPassword: boolean = false;
  private _permissions: string[] = [];
  private _bookmarkedBalloonEvents: BalloonEventModel[] = [];

  constructor(
    id: string | null = null,
    token: string,
    email: string | null = null,
    name: string | null = null,
    permissions: string[] = [],
    bookmarkedBalloonEvents: BalloonEventModel[] = [],
    avatar: string | null = null,
    hasPassword: boolean = false
  ) {
    this._id = id;
    this._token = token;
    this._email = email;
    this._name = name;
    this._permissions = permissions;
    this._bookmarkedBalloonEvents = bookmarkedBalloonEvents;
    this._avatar = avatar;
    this._hasPassword = hasPassword;
  }

  public static from(data: UserModel) {
    return new UserModel(
      data._id,
      data._token,
      data._email,
      data._name,
      data._permissions || [],
      data._bookmarkedBalloonEvents.map((e) => BalloonEventModel.from(e)),
      data._avatar,
      data._hasPassword
    );
  }

  get id() {
    return this._id;
  }

  get token() {
    return this._token;
  }

  get email() {
    return this._email;
  }

  get name() {
    return this._name;
  }

  get permissions() {
    return this._permissions;
  }

  get avatar() {
    return this._avatar;
  }

  get hasPassword() {
    return this._hasPassword;
  }

  set hasPassword(hasPassword: boolean) {
    this._hasPassword = hasPassword;
  }

  hasPermission(permission: string) {
    return this._permissions.includes(permission);
  }

  get bookmarkedBalloonEvents() {
    return this._bookmarkedBalloonEvents;
  }

  set bookmarkedBalloonEvents(bookmarkedBalloonEvents: BalloonEventModel[]) {
    this._bookmarkedBalloonEvents = bookmarkedBalloonEvents;
  }

  isBookmarked(balloonEvent: BalloonEventModel) {
    return this._bookmarkedBalloonEvents.some((e) => e.id === balloonEvent.id);
  }

  bookmarkClientSide(balloonEvent: BalloonEventModel) {
    this._bookmarkedBalloonEvents = [
      ...this._bookmarkedBalloonEvents,
      balloonEvent,
    ];
  }

  unbookmarkClientSide(balloonEvent: BalloonEventModel) {
    this._bookmarkedBalloonEvents = this._bookmarkedBalloonEvents.filter(
      (e) => e.id !== balloonEvent.id
    );
  }

  update(user: UserModel) {
    this._id = user._id;
    this._token = user._token;
    this._email = user._email;
    this._name = user._name;
    this._permissions = user._permissions;
    this._bookmarkedBalloonEvents = user._bookmarkedBalloonEvents;
    this._avatar = user._avatar;
    this._hasPassword = user._hasPassword;
  }
}
